module.exports = __webpack_public_path__ + "img/barometro.9997b0e1.webp";